import { SHELL } from '../shell';
import { useMyConnection } from './myConnection/useMyConnection';
import { MyDeviceInfo } from './myConnection/MyDeviceInfo';
import { MyConnectionSettings } from './myConnection/MyConnectionSettings';

/**
 * "내 연결 (이 기기)" 패널 — 기기 정보 + 설정을 **한 상자에** 그린다(로그인 후 "연결" 화면용).
 *
 * 2026-09-27 첫 화면 개편으로 로직은 `useMyConnection`, 화면은 `MyDeviceInfo`(기기 정보)·`MyConnectionSettings`(설정)로 나눴다 —
 * 로그인 전 첫 화면은 둘을 가운데 카드와 오른쪽 서랍에 **따로** 그린다(`HomeView`). 로그인 후 화면은 종전처럼 한 상자.
 *
 * ⚠️⚠️ 로그인 전에도 보여야 한다는 원칙(2026-09-08 실사용 — 피제어 전용 기기는 로그인하지 않는다)은 그대로다.
 * 껍데기(Tauri)가 정체성을 주입하지 않았으면(순수 웹, sidecar 스폰 실패) 아무것도 그리지 않는다.
 */
export function MyConnectionPanel() {
  const conn = useMyConnection();
  if (!conn.deviceCode && !SHELL.unattendedHost) return null;
  return (
    <div className="my-connection">
      <MyDeviceInfo conn={conn} />
      <MyConnectionSettings conn={conn} />
    </div>
  );
}
